import React, { useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { Heading1, Heading4, OrderSummaryAmount, ProductName, ProductUnitAmount, ProductUnitType } from '../../typography';
import { PALE, SOFT_TOMATO } from '../../colors';
import { formatCurrency } from '../../../utils';
import imgChevronDown from '../../../assets/chevron-down.svg';
import imgChevronUp from '../../../assets/chevron-up.svg';
import Product from '../molecules/Product';
import { useMediaQuery } from 'react-responsive';

interface OrderSummaryInterface {
  products: {
    _id: string;
    name: string;
    units: {
      type: string;
      price: string;
      quantity?: string | number
    }[];
    images: string[];
  }[];
  totalAmount: number;
  shippingAmount: 0;
}

const OrderSummary = ({
  products,
  totalAmount = 0,
  shippingAmount = 0
}: OrderSummaryInterface) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });
  const [isOpen, setIsOpen] = useState(isBigScreen);

  return (
    <Container>
      <Header onClick={() => {
        setIsOpen(!isOpen)
      }}>
        <div>
          <OrderSummaryTitle>
            {`Order Summary`.toUpperCase()}
          </OrderSummaryTitle>
          <img src={isOpen ? imgChevronUp : imgChevronDown} />
        </div>
        <OrderSummaryAmount>
          {formatCurrency(totalAmount + 0)}
        </OrderSummaryAmount>
      </Header>

      <AnimatePresence>
        {isOpen && (
          <Content
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            {products.map((product) => (
              <Product product={product} />
            ))}
            
            <HR />
            <OrderDetails>
              <ItemRow>
                <p>Subtotal</p>
                <p>{formatCurrency(totalAmount + shippingAmount)}</p>
              </ItemRow>
              <ItemRow>
                <p>Shipping</p>
                <p>{formatCurrency(shippingAmount)}</p>
              </ItemRow>
              <ItemRow>
                <strong>Total</strong>
                <strong>{formatCurrency(totalAmount + shippingAmount)}</strong>
              </ItemRow>
            </OrderDetails>
          </Content>
        )}
      </AnimatePresence>
    </Container>
  );
};

const Container = styled.div`
  overflow: hidden;
  background: #fff;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0rem 1rem;
  background: ${PALE};
  cursor: pointer;
  align-items: center;

  div {
    display: flex;
    align-items: center;

    img {
      height: 12px;
      width: 12px;
      padding: 0rem 0.5rem;
    }
  }
`;

const OrderSummaryTitle = styled.p`
  margin: 0 0;
  padding: 1rem 0rem;
  font-family: 'Poppins-Medium';
  font-size: 1rem;
`;

const ToggleButton = styled.div`
  font-size: 1.5rem;
  line-height: 1rem;
`;

const Content = styled(motion.div)`
  padding: 1rem;
`;

const HR = styled.hr`
  background-color: ${SOFT_TOMATO};
  color: ${SOFT_TOMATO};
  height: 1px;
  border: none;
`;

const OrderDetails = styled.div`

`;

const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0;

  p {
    font-family: 'Poppins-Medium';
    font-size: 0.9rem;
    margin: 0 0;
  }

  strong {
    font-family: 'Poppins-Medium';
    font-size: 0.9rem;
  }
`;


export default OrderSummary;
